var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-line-container"},_vm._l((_vm.value),function(item){return _c('time-item',{key:item.id,attrs:{"value":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }